<template>
  <div class="significant-measure" v-if="value">
    <div
      class="box"
      :style="
        bordered ? ` border: 1px solid ${color}` : `background-color:${color}`
      "
    >
      <component v-bind:is="icon" :fillColor="darkerColor"></component>
    </div>
    <div class="measure">
      <horizontal-title-tooltip-section
        :title="capTitle"
        :tooltip="tooltip"
        :color="darkerColor"
        size="s"
        v-if="tooltip"
      />
      <div v-else class="no-hint-title" :style="`color:${darkerColor}`">
        {{ capTitle }}
      </div>
      <div class="value-container">
        <span class="value">
          {{ dollars ? "$" : "" }}
          {{
            `${percentages ? (value * 100).toFixed(2) : value.toFixed(2)} ${
              percentages ? "%" : ""
            }`
          }}
          <span v-if="unit" class="unit"> p.a.</span>
        </span>
        <span
          class="comparison"
          :class="{ decrease: diff < 0 }"
          v-if="compareTo"
        >
          <up-icon v-if="diff > 0" />
          <down-icon v-else />
          {{
            percentages
              ? (Math.abs(diff) * 100).toFixed(2)
              : Math.abs(diff).toFixed(2)
          }}{{ percentages ? "%" : "" }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import DownIcon from "vue-material-design-icons/MenuDown.vue";
import HorizontalTitleTooltipSection from "./inputs/HorizontalTitleTooltipSection.vue";
import UpIcon from "vue-material-design-icons/MenuUp.vue";
export default {
  name: "significant-measure",
  components: { HorizontalTitleTooltipSection, UpIcon, DownIcon },
  props: {
    value: [Number, String],
    color: String,
    darkerColor: String,
    tooltip: String,
    title: String,
    icon: Object,
    percentages: Boolean,
    bordered: Boolean,
    compareTo: Number,
    unit: Boolean,
    dollars: Boolean,
  },
  computed: {
    diff() {
      return this.value - this.compareTo;
    },
    capTitle() {
      return this.title.toUpperCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.significant-measure {
  display: flex;
  column-gap: toRem(8);
  .value-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
  .value {
    font-size: toRem(20);
    font-weight: 500;
    position: relative;
    white-space: nowrap;
  }
  .unit {
    font-size: toRem(14);
  }
  .comparison {
    /* top: -7px;
      right: -53px;
      position: absolute;*/
    font-size: $xs-font;
    display: block;
    font-weight: 500;
    color: #0a68ec;
    white-space: nowrap;
    &.decrease {
      color: #e850a2;
    }
  }
  .measure {
    .flex {
      margin-bottom: 0;
    }
  }
  .no-hint-title {
    font-size: $s-font;
    font-weight: 500;
    white-space: nowrap;
  }
  .box {
    border-radius: $navItemRadius;
    width: toRem(54);
    height: toRem(48);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>